import { render, staticRenderFns } from "./ViewBlock.vue?vue&type=template&id=de42af16&scoped=true&"
import script from "./ViewBlock.vue?vue&type=script&lang=js&"
export * from "./ViewBlock.vue?vue&type=script&lang=js&"
import style0 from "./ViewBlock.vue?vue&type=style&index=0&id=de42af16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de42af16",
  null
  
)

export default component.exports